import clsx from 'clsx';
import { Tag } from '@hungryroot/icons';
import { Paragraph } from '@hungryroot/ramen';
import styles from './PromoBanner.module.css';

type Props = {
  promoText: string;
  className?: string;
  textClassName?: string;
};

export function PromoBanner({ promoText, className, textClassName }: Props) {
  return (
    <div className={clsx(styles.banner, className)}>
      <Tag className={styles.vector} />
      <Paragraph variant="caption" className={clsx(styles.text, textClassName)}>
        {promoText}
      </Paragraph>
    </div>
  );
}
